<template>
  <div class="m-market-3way">
    <div class="m-market-row">
      <template v-for="(title, index) in marketTitles">
        <div
          v-if="outcomesGroup.list[index].length > 0"
          :key="title"
          class="m-title"
        >
          {{ title }}
        </div>
      </template>
    </div>
    <div class="m-market-row">
      <template v-for="(outcomes, index) in outcomesGroup.list">
        <div
          v-if="outcomes.length > 0"
          :key="index"
          class="m-market-col"
        >
          <template v-for="outcome in outcomes">
            <Outcome
              :key="outcome.id"
              class="has-desc"
              :outcome="outcome"
              :market="market"
              :event="event"
              show-desc
            />
          </template>
        </div>
      </template>
    </div>
    <div
      v-if="outcomesGroup.other[0]"
      class="m-market-row"
    >
      <Outcome
        class="m-outcome--other"
        :outcome="outcomesGroup.other[0]"
        :market="market"
        :event="event"
        show-desc
      />
    </div>
  </div>
</template>

<script>
/**
 * 二、按1x2分为三列
 * 规则描述：对于Market中outcome数量较多的（大于20个），为方便用户查找目标selection，将selection按照1x2分为三列；
 * 要求：outcome数量大于20个，outcome名称为比分或者比赛结果（1x2）
 */
import Outcome from 'wap/match/Event/pagelet/Outcome'

export default {
  name: 'Market2ThreeWay',
  components: {
    Outcome
  },
  props: {
    market: {
      type: Object,
      default: () => ({})
    },
    event: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      outcomesGroup: {},
      marketTitles: ['Home', 'Draw', 'Away']
    }
  },
  computed: {
    checkIsActive() {
      const { market } = this
      return market.status
    }
  },
  watch: {
    'market.outcomes.order'(val) {
      if (val) {
        this.outcomesGroup = this.getOutcomeGroup()
      }
    },
    checkIsActive: {
      immediate: true,
      handler(val, oldVal) {
        if (!this.market.marketTypeDesc) return false
        this._timer && clearTimeout(this._timer)
        const option = this.market.marketTypeDesc.split('-')
        if (val !== 2 || (oldVal === undefined && val === 2)) {
          this.$emit('checkDeactive', val !== 2, option)
          return false
        }

        this._timer = setTimeout(() => {
          this.$emit('checkDeactive', val !== 2, option)
          clearTimeout(this._timer)
        }, 5000)
      }
    }
  },
  created() {
    this.outcomesGroup = this.getOutcomeGroup()
  },
  methods: {
    getOutcomeGroup() {
      const { order, map } = this.market.outcomes
      const home = []
      const draw = []
      const away = []
      const other = []
      const descArr = ['home', 'draw', 'away']
      order.forEach((id) => {
        const outcome = map[id]
        const description = outcome.description.toLowerCase()
        if (descArr.includes(description)) {
          if (description === 'home') {
            home.push(outcome)
          } else if (description === 'draw') {
            draw.push(outcome)
          } else if (description === 'away') {
            away.push(outcome)
          }
        } else {
          if (/\bto\b/.test(description)) {
            const descs = description.split(/to/)

            if (descs[0].trim() === 'home') {
              home.push(outcome)
            } else if (descs[0].trim() === 'draw') {
              draw.push(outcome)
            } else {
              away.push(outcome)
            }
          } else if (/:/.test(description)) {
            const descs = description.split(/:/)

            if (!descs || descs.length <= 1) {
              other.push(outcome)
              return
            }

            if (descs[0] > descs[1]) {
              home.push(outcome)
            } else if (descs[0] === descs[1]) {
              draw.push(outcome)
            } else {
              away.push(outcome)
            }
          }

          if (description === 'other') {
            other.push(outcome)
          }
        }
      })
      return {
        list: [home, draw, away],
        other
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-market-3way {
  .m-market-row {
    align-items: flex-start;
    margin: 0;

    .m-market-col {
      flex: 1;
      margin-right: 4/@rem;

      &:last-child {
        margin-right: 0;
      }
    }

    .m-outcome {
      width: 100%;
      margin-bottom: 4/@rem;
    }

    .m-outcome--other {
      justify-content: center;
      font-size: 14/@rem;

      .desc {
        flex: none;
      }

      .odds {
        flex: none;
        margin-left: 4/@rem;
      }
    }
  }
}
</style>
